// extracted by mini-css-extract-plugin
module.exports = {"save-filter-container":"save-filter-inspector_save-filter-container__35z8C"};